import { useCallback, type ForwardedRef } from "react";

/** Adapts a forwarded `Ref<HTMLElement>` into a callback ref any polymorphic element accepts. */
export function useElementRef<T extends Element>(ref: ForwardedRef<T>) {
  return useCallback(
    (node: T | null) => {
      if (typeof ref === "function") ref(node);
      else if (ref) ref.current = node;
    },
    [ref],
  );
}
